import React, { useState } from 'react'
import './Options.css'
import OrderCompletion from './OrderCompletion'
import AssignTechnician from './AssignTechnician'
import HandlingStatus from './HandlingStatus';

function Options({ detailedData }) {
  const [toggleAssignTechnician, setToggleAssignTechnician] = useState(false);
  const [toggleOrderCompletion, setToggleOrderCompletion] = useState(false);
  const [toggleHandlingStatus, setToggleHandlingStatus] = useState(false);

  const handleClickAssign = () => {
    setToggleAssignTechnician(!toggleAssignTechnician);
  }

  const handleClickOrder = () => {
    setToggleOrderCompletion(!toggleOrderCompletion);
  }

  const handleClickStatus = () => {
    setToggleHandlingStatus(!toggleHandlingStatus);
  }

  return (
    <div>
      <div className='toggle-box'>
        <button onClick={handleClickAssign}>-</button>
        <h6>Assigning WO</h6>
      </div>
      {toggleAssignTechnician && <AssignTechnician detailedData={ detailedData }/>}
      <div className='toggle-box'>
        <button onClick={handleClickOrder}>-</button>
        <h6>WO Service Completion Check (required for TCA submission)</h6>
      </div>
      {toggleOrderCompletion && <OrderCompletion/>}
      <div className='toggle-box'>
        <button onClick={handleClickStatus}>-</button>
        <h6>WO Handling History</h6>
      </div>
      {toggleHandlingStatus && <HandlingStatus/>}
    </div>
  )
}

export default Options
